<template>
    <tinymce-editor
        api-key="no-api-key"
        v-model="question.text"
        :disabled="disabled"
        plugins="code table charmap autolink link lists media visualblocks image imagetools paste fullscreen autoresize"
        toolbar="forecolor backcolor bold italic | numlist bullist media | alignleft aligncenter alignright outdent
            indent | code charmap visualblocks | link image embedgooglemap fileattach | fullscreen"
        :init="{
            skin_url: '/js/tinymce/skins/ui/oxide',
            content_css: '/css/tinymce.css',
            imagetools_toolbar: 'imageoptions',
            contextmenu: `link image inserttable | cell row column deletetable`,
            branding: false,
            language: this.locale,
            br_in_pre: false,
            menubar: false,
            paste_data_images: false,
            automatic_uploads: false,
            image_title: true,
            file_picker_types: false,
            relative_urls : false,
            remove_script_host : true,
            min_height: 100,
            mobile: false,
            statusbar: false,
            autoresize: true,
       }"
    ></tinymce-editor>
</template>

<script>
import Editor from '@tinymce/tinymce-vue';
import {mapGetters} from "vuex";

export default {
    name: "QuestionTinymceEditor",
    components: {
        'tinymce-editor': Editor
    },
    props: {
        question: Object,
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapGetters('tests', [
            'locale',
        ]),
    }
}
</script>
